import React from 'react';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer py-4 mt-auto">
      <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between">
        <div className="small">© {year} Family Ring</div>
        <div className="small">
          <a href="/legalDocs/PrivacyPolicy" className="text-decoration-none me-3">Privacy</a>
          <a href="/legalDocs/TermsAndConditions" className="text-decoration-none">Terms</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

